import type { DateTimeValue } from '@elfsight/configurator-contracts';
import type { FilterOptions } from '../mapFilters';
import { findMaxDate } from '../utils';

export const filterByDate = (
  postCreationDate: number,
  { include }: FilterOptions<DateTimeValue<'datetime'>>
) => {
  const flags = {
    shouldInclude: false,
    shouldExclude: false
  };

  // Если максимальная дата из массива дат меньше, чем выбранная, то пускаем
  if (include.length) {
    const dates = include.map(({ date }) => date);
    const maxDate = findMaxDate(dates);

    flags.shouldInclude = maxDate < new Date(postCreationDate);
  }

  return flags;
};
